const regMethods = {
    methods: {
        // 手机号码验证
        phoneReg (phoneNumber) {
            const reg = /^[1][3-9][0-9]{9}$/
            return reg.test(phoneNumber)
        },
        identityReg(IDCard){
            var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            if (!reg.test(IDCard)) {return false;}
            return true
        },
        pswReg(str){
            var reg = /^[^\s]{6,16}$/
            if(!reg.test(str)){
                return false
            }
            return true
        }
    }
}
export default regMethods
